module.exports = __WEBPACK_EXTERNAL_MODULE_60__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","platformBrowser"],"commonjs":"@angular/platform-browser","commonjs2":"@angular/platform-browser","amd":"@angular/platform-browser"}
// module id = 60
// module chunks = 0